import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Usuario } from 'app/domain/usuario';
import { LiquidarPago, Liquidacion, ServicioAdicinal, Contenedor, NotaCredito, Transaccion, EnviarPago, Cita, EnviarCita, bl, Busqueda, sendContenedor, Transportista } from './impo';

//import publico
import { url_servicios, url_servicios_pdf, new_transportista } from 'app/domain/publico'

//import domains
import { PDF } from 'app/view/expo/expo';

declare var $: any;

@Injectable()
export class ImpoService {
    constructor(private http: Http, private router: Router) {
        var headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("key_apm"));
        this.options = new RequestOptions({ headers: headers });

        this.usuario = JSON.parse(localStorage.getItem("usuario"));
    }

    options;
    usuario: Usuario;

    getListaBlDefecto(busqueda: Busqueda) {
        //console.log(ruc, tiposervicio, usuario, busqueda);
        var method = "cabecera?" + "ruc=" + this.usuario.rucEmpresa + "&tipoServicio=" + 1 + "&usuario=" + this.usuario.usuarioCuenta + "&pagina=" + busqueda.pagina;

        //console.log(busqueda);

        if (busqueda.fechainicio && busqueda.fechainicio != "" && busqueda.fechainicio != undefined) { method += "&finicio=" + this.convertirFecha(busqueda.fechainicio); } else { method += "&finicio=" }
        if (busqueda.fechafin && busqueda.fechafin != "" && busqueda.fechafin != undefined) { method += "&ffin=" + this.convertirFecha(busqueda.fechafin); } else { method += "&ffin=" }
        if (busqueda.estadoBl != "0" && busqueda.estadoBl != undefined) { method += "&estado=" + busqueda.estadoBl; } else { method += "&estado=" }
        if (busqueda.numeroBl && busqueda.numeroBl != "" && busqueda.numeroBl != undefined) { method += "&numeroBl=" + busqueda.numeroBl; } else { method += "&numeroBl=" }

        return this.HTTPGET(method);

    }

    getListaBL(busqueda: Busqueda) {
        var method = "bl?ruc=" + this.usuario.rucEmpresa + "&tipoServicio=" + 1 + "&usuario=" + this.usuario.usuarioCuenta;

        if (busqueda.numeroBl != "" && busqueda.numeroBl != undefined)
            method += "&bl=" + busqueda.numeroBl;
        if (busqueda.tipoBl != "0" && busqueda.tipoBl != undefined && busqueda.tipoBl != "")
            method += "&tipoBl=" + busqueda.tipoBl;
        if (busqueda.manifiesto != undefined) {
            method += "&anioManifiesto=" + busqueda.manifiesto.split("-")[0] + "&nroManifiesto=" + busqueda.manifiesto.split("-")[1];
        }

        return this.HTTPGET(method);
    }

    getManifiesto(numeroBl, tipoBl) {
        var method = "manifiesto?";
        if (numeroBl != undefined || numeroBl != "")
            method += "&bl=" + numeroBl;
        if (tipoBl != undefined || tipoBl != "")
            method += "&tipoBl=" + tipoBl;

        return this.HTTPGET(method);
    }

    /**
     * DETALLE DE BL
     */

    getDetalleBl(ct: sendContenedor) {

        var method = "contenedores";

        return this.HTTPPOST(method, ct);
    }

    //get Detalle del contenedor

    getDetalleContenedor() {
        var method = "contenedores/detalle";
        return this.HTTPGET(method)
    }

    getActividad(transaccionDetID) {
        var method = "citas/detalle?transaccionDetID=" + transaccionDetID;
        return this.HTTPGET(method);
    }

    //get servicios adicionales
    getServiciosAdicionales(bl: bl, ct: Contenedor) {
        var method = "servicios/adicionales?codigoLocacion=" + bl.codigoLocacion + "&ruc=" + this.usuario.rucEmpresa + "&tipoServicio=" + 1 + "&transaccionId=" + ct.transaccionId + "&linea=" + bl.linea;
        return this.HTTPGET(method);
    }

    /**
     * SERVICIOS DE PAGO
     */

    getTransportistas(bl: bl, ct: Contenedor, opcion) {

        var method = "transportista?codigoLocacion=" + bl.codigoLocacion + "&ruc=" + this.usuario.rucEmpresa + "&tipoServicio=" + 1;

        if (opcion == 1)
            method += "&transaccionId=" + 0;
        else if (opcion == 2)
            method += "&transaccionId=" + ct.transaccionId;
        return this.HTTPGET(method);
    }

    modificarTransportista(ct: Contenedor, tr: Transportista) {
        var method = "modificar/transportista";

        var body = new new_transportista();
        body.ruc = this.usuario.rucEmpresa;
        body.usuario = this.usuario.usuarioCuenta;
        body.transaccionDetID = ct.transaccionId;
        body.rucTransportista = tr.rucEmpresa;
        body.razonSocial = tr.razonSocialEmpresa;

        return this.http.put(url_servicios + method, body, this.options)
            .map(resp => resp.json())
            .catch(error => this.ERROR(error));

        // return this.HTTPPUT(method, body);
    }

    getClientePago(codigoLocacion, ruc, codigoConsignatario) {
        var method = "cliente/detalle?codigoLocacion=" + codigoLocacion + "&ruc=" + ruc + "&tipoServicio=1&codigoConsignatario=" + codigoConsignatario;
        return this.HTTPGET(method);
    }


    getMonedaCliente(codigoCliente, ruc, codigoLocacion, linea) {
        var method = "pago/detalle?codigoCliente=" + codigoCliente + "&ruc=" + ruc + "&tipoServicio=1&codigoLocacion=" + codigoLocacion + "&linea=" + linea;
        return this.HTTPGET(method);
    }

    liquidar: LiquidarPago;

    liquidarPago(liquidacion: Liquidacion, detalle_bl: bl, ls_contenedores: Array<Contenedor>) {
        this.liquidar = new LiquidarPago();
        var method = "pago/liquidar";

        this.liquidar.ruc = this.usuario.rucEmpresa;
        this.liquidar.tipoServicio = "1";
        this.liquidar.codigoLocacion = detalle_bl.codigoLocacion;
        this.liquidar.codigoNave = detalle_bl.codigoNave;
        this.liquidar.viaje = detalle_bl.numeroViaje;
        this.liquidar.codRumbo = detalle_bl.codigoRumbo;
        this.liquidar.regimen = detalle_bl.codigoRegimen;
        this.liquidar.bl = detalle_bl.documento;
        this.liquidar.tipoBl = "M";
        this.liquidar.anioMfto = detalle_bl.nroManifiesto.split("-")[0];
        this.liquidar.nroMfto = detalle_bl.nroManifiesto.split("-")[1];
        this.liquidar.codCliente = liquidacion.cliente;
        this.liquidar.codigoMoneda = liquidacion.moneda;
        this.liquidar.tipoComprobante = liquidacion.comprobante;
        this.liquidar.usuarioLogueado = this.usuario.usuarioCuenta;
        this.liquidar.listaContenedores = this.generarXmlTransaccion(ls_contenedores);

        return this.HTTPPOST(method, this.liquidar)
    }

    servicios: Array<ServicioAdicinal>;
    generarXmlTransaccion(ls_contenedores: Array<Contenedor>) {
        var item: string = "";

        for (var c = 0; c < ls_contenedores.length; c++) {
            if (ls_contenedores[c]) {
                item += "<Item>";
                item += "<NroDetalle_DO>" + ls_contenedores[c].nroDetalleDo + "</NroDetalle_DO>";
                item += "<Contenedor>" + ls_contenedores[c].nroContenedor + "</Contenedor>";
                item += "<FechaDevolucion>" + this.convertirFecha(ls_contenedores[c].fechaLimteDevolucion) + "</FechaDevolucion>";
                item += "<RUCTransportista>" + ls_contenedores[c].ruc_transportista + "</RUCTransportista>";
                item += "<RZTransportista>" + ls_contenedores[c].raz_transportista + "</RZTransportista>";
                item += "<CodigoLugarDevolucion>" + ls_contenedores[c].codigoDevolucion + "</CodigoLugarDevolucion>";
                item += "<FacturaCosmos>" + ((ls_contenedores[c].facturaCosmos && ls_contenedores[c].facturaCosmos.length > 0) ? ls_contenedores[c].facturaCosmos : "") + "</FacturaCosmos>";

                if (!ls_contenedores[c].ls_servicios) {
                    item += "<ServicioAdicional></ServicioAdicional>"
                }

                if (ls_contenedores[c].ls_servicios) {
                    for (var i = 0; i < ls_contenedores[c].ls_servicios.length; i++) {
                        item += "<ServicioAdicional>"
                        item += "<CodigoServicio>" + ls_contenedores[c].ls_servicios[i].codigoServicio + "</CodigoServicio>";
                        item += "</ServicioAdicional>"
                    }
                }
                item += "</Item>";
            }
        }

        ////console.log("<Detalles>" + item + "</Detalles>");
        return "<Detalles>" + item + "</Detalles>";
    }

    getNotasCredito(liquidacion: Liquidacion, detalle_bl: bl) {
        var method = "pago/cliente?tipoServicio=" + 1 + "&ruc=" + this.usuario.rucEmpresa + "&codigoCliente=" + liquidacion.cliente + "&codigoMoneda=" + liquidacion.moneda + "&codigoLocacion=" + detalle_bl.codigoLocacion;
        return this.HTTPGET(method)
    }

    cancelarTransaccion(idTransaccion, tipoCliente) {
        var method = "pago/cancelar?idTransaccion=" + idTransaccion;

        /**
         *  Opcion 1: Botón Cancelar de Generar Codigo de pago(TipoCliente 2 - Contado)
            Opción 2: Botón Cancelar de CLIENTE CON PAGO TOTAL(Tipo Cliente 1 - Exonerado)
            opción 3: Botón Cancelar de CLIENTE CUENTA CON SALDO(TipoCliente 3 - Credito con saldo)
            Opcion 4: Botón Finalizar de CLIENTE NO CUENTA CON SALDO(TipoCliente 4 - Credito sin saldo)
            Opción 5: Botón Cancelar de NOTAS DE CREDITO y / o CONTADO(TipoCliente 4 - Credito sin saldo)
         */

        if (tipoCliente == "1") {
            method += "&nroOpcion=2"
        } else if (tipoCliente == "2") {
            method += "&nroOpcion=1"
        } else if (tipoCliente == "3") {
            method += "&nroOpcion=3"
        } else if (tipoCliente == "4") {
            method += "&nroOpcion=4"
        } else if (tipoCliente == "5") {
            method += "&nroOpcion=5"
        }


        return this.HTTPGET(method)
    }

    generarCodigoPago(transaccion: Transaccion, ls_notasCredito: Array<NotaCredito>) {
        var method = "pago";
        var enviarPago: EnviarPago = new EnviarPago();

        if (ls_notasCredito.length > 0)
            enviarPago.listaNotasCredito = this.generarXmlNotasCredito(ls_notasCredito);
        else
            enviarPago.listaNotasCredito = "";

        /*
         *  Opción 1: Botón Generar codigo de  pago (TipoCliente 2 - Contado)
            Opcion 2: Botón Finalizar CLIENTE CON PAGO TOTAL (Tipo Cliente 1-Exonerado)
            Opcion 3: Botón Finalizar CLIENTE CUENTA CON SALDO (TipoCliente 3-Credito con saldo)
            Opción 4: Botón Generar codigo de pago con NOTAS DE CREDITO y/o CONTADO (TipoCliente 4-Credito sin saldo)
         */

        if (transaccion.tipoCliente == "1") {
            enviarPago.tipoCliente = "2"
        } else if (transaccion.tipoCliente == "2") {
            enviarPago.tipoCliente = "1"
        } else if (transaccion.tipoCliente == "3") {
            enviarPago.tipoCliente = "3"
        } else if (transaccion.tipoCliente == "4") {
            enviarPago.tipoCliente = "4"
        }

        //enviarPago.tipoCliente = transaccion.tipoCliente;
        enviarPago.transaccionID = transaccion.transaccionID;

        //console.log(enviarPago);
        //var body = "transaccionID=" + transaccion.transaccionID + "&tipoCliente=" + transaccion.tipoCliente + "&listaNotasCredito=" + this.generarXmlNotasCredito(ls_notasCredito);
        return this.HTTPPOST(method, enviarPago)
    }

    generarXmlNotasCredito(ls_notasCredito: Array<NotaCredito>) {
        var item: string = "";

        for (var c = 0; c < ls_notasCredito.length; c++) {
            if (ls_notasCredito[c]) {
                item += "<Item>";
                item += "<TipoDocumento>" + ls_notasCredito[c].tipoDocumento + "</TipoDocumento>";
                item += "<NroDocumento>" + ls_notasCredito[c].nroNota + "</NroDocumento>";
                item += "<Monto>" + ls_notasCredito[c].monto + "</Monto>";
                item += "<MonedaNC>" + (ls_notasCredito[c].monedaNc).trim() + "</MonedaNC>";
                item += "<FechaDocumento>" + this.convertirFechaNota(ls_notasCredito[c].fechaDocumento) + "</FechaDocumento>";
                item += "</Item>";
            }
        }

        return "<NotasCredito>" + item + "</NotasCredito>";
    }

    convertirFechaNota(fecha: string) {
        var nueva_fecha = "";
        nueva_fecha = fecha.split("-")[0] + fecha.split("-")[1] + fecha.split("-")[2];
        return nueva_fecha;
    }

    obtener_liquidacion(transaccionId) {
        var method = "liquidacion/detalle?DLD_RucEmpresaLogeada=" + this.usuario.rucEmpresa + "&DLD_UsuarioLogeado=" + this.usuario.usuarioCuenta + "&DLD_TransaccionID=" + transaccionId;
        return this.HTTPGET(method);
    }

    getCuadriculaCitas(ruc, usuario, ct: Contenedor, bl: bl, fechaCita) {
        var method = "citas/cuadricula?ruc=" + ruc + "&usuario=" + usuario + "&tipoServicio=1"

        //console.log(ct, bl);
        console.log(ct);
        console.log(bl);

        if (bl.codigoLocacion != undefined || bl.codigoLocacion != "") {
            method += "&codigoLocacion=" + bl.codigoLocacion;
        }

        if (ct.lugarDevolucion != undefined || ct.lugarDevolucion != "") {
            method += "&codigoLugarCita=" + ct.codigoDevolucion
        }
        if (fechaCita != "") {
            method += "&fechaCita=" + fechaCita;
        }

        return this.HTTPGET(method);
    }

    getCitasDisponibles(ct: Contenedor, bl: bl, fechaCita) {
        var method = "citas?ruc=" + this.usuario.rucEmpresa + "&usuario=" + this.usuario.usuarioCuenta + "&tipoServicio=" + 1;
        method += "&codigoLocacion=" + bl.codigoLocacion;
        method += "&codigoLocacion=" + bl.codigoLocacion;
        method += "&codigoLocacion=" + bl.codigoLocacion;
        method += "&fechaCita=" + fechaCita;
        method += "&codigoLugarCita=" + ct.codigoDevolucion;
        method += "&transaccionID=" + bl.transaccionId;

        return this.HTTPGET(method)
    }

    generarCita(bl: bl, ls_citas: Array<Cita>, cnt: Contenedor, accion: string) {
        var method = "citas"

        var enviar: EnviarCita = new EnviarCita();

        enviar.ruc = this.usuario.rucEmpresa;
        enviar.usuario = this.usuario.usuarioCuenta;
        enviar.codigoLocacion = bl.codigoLocacion;
        enviar.tipoServicio = "1";
        enviar.tipoAccion = accion;
        enviar.codigoLugarCita = cnt.codigoDevolucion;
        enviar.transaccionID = bl.transaccionId
        enviar.listaDetalles = this.generarXMLcita(ls_citas)

        //console.log(enviar);

        return this.HTTPPOST(method, enviar);
    }

    generarXMLcita(ls_citas: Array<Cita>) {
        var item: string = "";

        for (var c = 0; c < ls_citas.length; c++) {
            if (ls_citas[c]) {
                item += "<Item>";

                item += "<TransaccionDetID>" + ls_citas[c].transaccionId + "</TransaccionDetID>";
                item += "<NroDetalle_DO>" + ls_citas[c].nroDetalleDTO + "</NroDetalle_DO>";
                item += "<Contenedor>" + ls_citas[c].nroContenedor + "</Contenedor>";
                item += "<CitaConfigID>" + ls_citas[c].citaConfigID + "</CitaConfigID>";
                // item += "<FechaCita>" + ls_citas[c].fecha this.convertirFechaCita(fecha_cita) + "</FechaCita>";
                item += "<FechaCita>" + this.convertirFechaCita(ls_citas[c].fecha) + "</FechaCita>";
                item += "<HoraCitaInicio>" + ls_citas[c].horaCitaInicio + "</HoraCitaInicio>";
                item += "<NCupo>" + ls_citas[c].nCupo + "</NCupo>";

                item += "</Item>";
            }
        }

        return "<Detalles>" + item + "</Detalles>";
    }

    convertirFecha(fecha: string) {
        var nueva_fecha = "";
        nueva_fecha = fecha.split("/")[2] + fecha.split("/")[1] + fecha.split("/")[0];
        return nueva_fecha;
    }

    //METODO CONVERTIR FECHA
    convertirFechaCita(str: string) {
        var date = new Date(str),
            year = date.getFullYear(),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [year, mnth, day].join("");
    }

    private HTTPGET(method) {
        return this.http.get(url_servicios + method, this.options)
            .map(resp => resp.json())
            .catch(error => this.ERROR(error));
    }

    private HTTPPOST(method, body) {
        return this.http.post(url_servicios + method, body, this.options)
            .map(resp => {
                return resp.json();
            })
            .catch(error => this.ERROR(error));
    }

    private HTTPPUT(method, body) {
        return this.http.put(url_servicios + method, body, this.options)
            .map(resp => resp.statusText)
            .catch(error => this.ERROR(error));
    }

    private ERROR(e: any) {
        switch (e.status) {
            case 400:
                if (JSON.parse(e._body).message != null)
                    return Observable.throw(JSON.parse(e._body).message);
                else
                    return Observable.throw("");
            case 401:
                window.localStorage.removeItem("cse_technology");
                window.localStorage.removeItem("cse_modality");
                window.localStorage.removeItem("key_apm");
                window.localStorage.removeItem("usuario");
                this.router.navigate(['/iniciar-sesion']);
                $('#expires').html(
                    '<div class="alert alert-danger">' +
                    "Sesion ha expirado ..." +
                    '</div>'
                );
                return Observable.throw("Sesion ha expirado, Cerrrando sesion ...");
            case 500:
                return Observable.throw("Internal Server Error");
            default:
                return Observable.throw("Ocurrio un error");
        }
    }

    get_comprobante_pdf(comprobante: PDF) {
        var url_pdf = url_servicios_pdf + "WS_TCI/Service.asmx?op=Obtener_PDF"

        var xml =
            '<?xml version="1.0" encoding="utf-8"?>' +
            '<soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">' +
            '<soap12:Body>' +
            '<Obtener_PDF xmlns="http://tempuri.org/">' +
            '<oENPeticion>' +
            '<IndicadorComprobante>' + 1 + '</IndicadorComprobante>' +
            '<Serie>' + comprobante.Serie + '</Serie>' +
            '<Numero>' + comprobante.Numero + '</Numero>' +
            '<TipoComprobante>' + comprobante.TipoComprobante + '</TipoComprobante>' +
            '<Ruc>' + 20107012011 + '</Ruc>' +
            '</oENPeticion>' +
            '<Cadena></Cadena>' +
            '</Obtener_PDF>' +
            '</soap12:Body>' +
            '</soap12:Envelope>'

        var headers = new Headers();
        headers.append('Content-Type', 'text/xml');
        var option = new RequestOptions({ headers: headers });
        return this.http.post(url_pdf, xml, option)
            .map(resp => {
                return resp.text();
            }, error => {
                //console.log(error)
            })
    }

}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/view/impo/impo.service.ts